/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { SubtleLink } from 'src/styles';
import { overflowEllipsis } from 'src/styles/mixins';

export const DetailsList = styled.ul({
  listStyleType: 'none',
  paddingLeft: 0,
});

export const DetailsListFooter = styled.div({
  /* Match ModalFooter styles */
  paddingTop: `14px`,
  paddingBottom: token('space.250'),
});

export const ListItem = styled.li({
  display: 'flex',
  alignItems: 'center',
  '& + &': {
    marginTop: token('space.100'),
  },
});

export const ListItemAvatar = styled.div({
  /* Remove extra height from avatar wrapper: https://css-tricks.com/fighting-the-space-between-inline-block-elements/ */
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  fontSize: 0,
  marginRight: token('space.100'),
});

export const ListItemLink = styled(SubtleLink)(overflowEllipsis(), {
  marginLeft: token('space.100'),
  marginRight: token('space.100'),
});

export const ListItemIcon = styled(SubtleLink)({
  flexShrink: 0,
  marginLeft: 'auto',
  /* Remove extra height from icon wrapper */
  display: 'flex',
});
